export default "__VITE_ASSET__846202b1__"